export default {"src":"/_next/static/media/cf.4fc8f7fb.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};